import { createReducer } from "@reduxjs/toolkit";
import { APP_CONFIG } from "../actions/types";

const initialState = {
  loading: true,
  subdomain: null,
  company: null,
  logo: "/images/layout/logo.png",
};

const appReducer = createReducer(initialState, (builder) => {
  builder.addCase(APP_CONFIG, (s, { payload = {} }) => {
    s.loading = false;
    if (payload.logo) s.logo = payload.logo;
  });
});

export default appReducer;
